module.exports = "/_next/static/images/a9941da53263f760555ad5005a7abbef-pj-woman-working@1x.jpg";